
import React from "react";
import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { Calendar, Download, User } from "lucide-react";
import { formatDistanceToNow } from "date-fns";
import { Agent } from "@/models/agent";

interface AgentHeaderProps {
  agent: Agent;
}

export const AgentHeader: React.FC<AgentHeaderProps> = ({ agent }) => {
  return (
    <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6 mb-6">
      <div>
        <div className="flex items-center gap-2 mb-2">
          <Badge className="bg-primary/20 text-primary hover:bg-primary/30">
            <Link to={`/category/${encodeURIComponent(agent.category)}`}>{agent.category}</Link>
          </Badge>
          {agent.pricingModel === "free" ? (
            <Badge variant="outline" className="bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300 border-green-200 dark:border-green-800">
              Free
            </Badge>
          ) : (
            <Badge variant="outline" className="bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300 border-blue-200 dark:border-blue-800">
              Premium
            </Badge>
          )}
        </div>
        
        <h1 className="text-3xl font-bold mb-2">{agent.name}</h1>
        
        <div className="flex items-center text-sm text-muted-foreground mb-4">
          <User className="h-4 w-4 mr-1" />
          <span className="mr-3">By {agent.owner_id.substring(0, 8)}</span>
          <Calendar className="h-4 w-4 mr-1" />
          <span className="mr-3">Created {formatDistanceToNow(new Date(agent.createdAt), { addSuffix: true })}</span>
          <Download className="h-4 w-4 mr-1" />
          <span>{agent.downloads} downloads</span>
        </div>
        
        <p className="text-muted-foreground mb-6">{agent.description}</p>
      </div>
    </div>
  );
};
